module.exports = __webpack_public_path__ + "img/gh-36006.asm.2f39fea2.jpg";